import { createFileRoute } from "@tanstack/react-router";
import { NotificationsViewPage } from "@/pages/notifications-view/ui/notifications-view-page";

const NotificationsViewRoute = () => {
  return <NotificationsViewPage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/notifications",
)({
  component: NotificationsViewRoute,
});
